import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {REMOVE_MODAL_VIEW} from 'modules/cart/constants';
import {Basket, ProductOfferDetail} from 'models';
import {ICartState} from 'modules/cart/types';
import {ICartProduct} from '../models';

export const cartModuleName = 'cart';

const initialState: ICartState = {
    afterRemoveToast: '',
    checkedList: [],
    isLegalEntity: false,
    isOpenAvailabilities: false,
    newAdded: null,
    productsList: [],
    removeId: null,
    removeModalView: REMOVE_MODAL_VIEW.ASSIGNED,
    selectedProductId: null,
    total: 0,
};

export const cartSlice = createSlice({
    initialState,
    name: cartModuleName,
    reducers: {
        actionChangeCheckedList(state: ICartState, {payload}: PayloadAction<ProductOfferDetail['id']>) {
            state.checkedList = state.checkedList.includes(payload)
                ? state.checkedList.filter((id) => id !== payload)
                : [...state.checkedList, payload];
        },
        actionSetAddedProduct(state: ICartState, {payload}: PayloadAction<ICartProduct | null>) {
            state.newAdded = payload;
        },
        actionSetAfterRemoveToast(state: ICartState, {payload}: PayloadAction<ICartState['afterRemoveToast']>) {
            state.afterRemoveToast = payload;
        },
        actionSetCart(state: ICartState, {payload}: PayloadAction<Basket | undefined>) {
            state.productsList = payload?.products ?? [];
            state.total = payload?.total ?? 0;
        },

        actionSetCheckedList(state: ICartState, {payload}: PayloadAction<ProductOfferDetail['id'][]>) {
            state.checkedList = payload;
        },

        actionSetIsOpenAvailabilities(state: ICartState, {payload}: PayloadAction<ICartState['isOpenAvailabilities']>) {
            state.isOpenAvailabilities = payload;
        },

        actionSetLegalStatus(state: ICartState, {payload}: PayloadAction<ICartState['isLegalEntity']>) {
            state.isLegalEntity = payload;
        },

        actionSetRemoveId(state: ICartState, {payload}: PayloadAction<ICartState['removeId']>) {
            state.removeId = payload;
        },

        actionSetRemoveModalView(state: ICartState, {payload}: PayloadAction<ICartState['removeModalView']>) {
            state.removeModalView = payload;
        },

        actionSetSelectedProductId(state: ICartState, {payload}: PayloadAction<ICartState['selectedProductId']>) {
            state.selectedProductId = payload;
        },
    },
});

export const {
    actions: {
        actionSetAfterRemoveToast,
        actionSetIsOpenAvailabilities,
        actionSetRemoveId,
        actionSetRemoveModalView,
        actionChangeCheckedList,
        actionSetCart,
        actionSetCheckedList,
        actionSetLegalStatus,
        actionSetSelectedProductId,
        actionSetAddedProduct,
    },
} = cartSlice;

export const {reducer: cartReducer} = cartSlice;
